import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { useQueryClient } from 'react-query';
import { useHistory } from 'react-router-dom';

import { useRestaurant } from 'query/hooks';

import { Input, Button } from 'components';
import { WarningIcon } from 'icons';
import messages from 'messages';

function Sender({ ...props }) {
    const { formatMessage } = props.intl;

    const queryClient = useQueryClient();
    const history = useHistory();
    const domain = useRestaurant()?.data?.domain || '';
    const bag = queryClient.getQueryData('bag') || [];

    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [errors, setErrors] = useState({});

    const handleValidationEmail = (value) => {
        setEmail(value);
        setErrors({ ...errors, email: false });

        const pattern = /\S+@\S+\.\S+/;
        const result = pattern.test(value);

        if (result === false) {
            setErrors({ ...errors, email: true });
        }
    };

    const handleValidationName = (value, option) => {
        setErrors({ ...errors, firstName: false, lastName: false });

        if (option === 'firstName') {
            setFirstName(value);
        } else {
            setLastName(value);
        }

        if (!value) {
            if (option === 'firstName') {
                setErrors({ ...errors, firstName: true });
            } else {
                setErrors({ ...errors, lastName: true });
            }
        }
    };

    const handleFields = () => {
        if (
            errors.email ||
            errors.firstName ||
            errors.lastName ||
            !firstName ||
            !lastName ||
            !email
        ) {
            return true;
        }

        return false;
    };

    const saveSender = () => {
        const data = {
            firstName,
            lastName,
            email,
        };

        queryClient.setQueryData('sender', data);
        localStorage.setItem('sender', JSON.stringify(data));

        history.push(`/${domain}/review`);
    };

    if (!bag.length) {
        history.push(`/${domain}/choose`);
    }

    return (
        <div className="page-wrapper page-sender">
            <h2 className="title">{formatMessage(messages.senderTitle)}</h2>
            <h3 className="subtitle caramel">{formatMessage(messages.senderDescription)}</h3>

            <Input
                data-test="first-name-field"
                id="first-name"
                type="text"
                placeholder={formatMessage(messages.genericLabelFirstName)}
                value={firstName}
                customStyles={{
                    margin: '10px auto 8px',
                    width: '100%',
                }}
                onChange={(e) => handleValidationName(e, 'firstName')}
            />

            {errors?.firstName ? (
                <p className="error">
                    <WarningIcon size={16} />
                    {formatMessage(messages.errorFirstname)}
                </p>
            ) : (
                ''
            )}

            <Input
                id="last-name"
                type="text"
                placeholder={formatMessage(messages.genericLabelLastName)}
                value={lastName}
                customStyles={{
                    margin: '10px auto 8px',
                    width: '100%',
                }}
                onChange={(e) => handleValidationName(e, 'lastName')}
                data-test="input-last-name"
            />

            {errors?.lastName ? (
                <p className="error">
                    <WarningIcon size={16} />
                    {formatMessage(messages.errorLastname)}
                </p>
            ) : (
                ''
            )}

            <Input
                id="email"
                type="text"
                placeholder={formatMessage(messages.genericLabelEmail)}
                value={email}
                customStyles={{
                    margin: '10px auto 8px',
                    width: '100%',
                }}
                onChange={(e) => handleValidationEmail(e)}
                data-test="input-email"
            />

            {errors?.email ? (
                <p className="error">
                    <WarningIcon size={16} />
                    {formatMessage(messages.errorEmail)}
                </p>
            ) : (
                ''
            )}

            <Button
                disabled={handleFields()}
                onClick={() => saveSender()}
                data-test="button-continue"
            >
                {formatMessage(messages.genericButtonContinue)}
            </Button>
        </div>
    );
}

export default injectIntl(React.memo(Sender));
